<template>
  <div class="login-container">
      <!--<div style="width: 876px">-->
          <div class="login-card-container">
              <div class="login-card">
                  <el-form class="login-form" ref="loginForm" label-width="7.25rem" :model="loginForm" :rules="loginRules" :show-message="true">
                      <el-form-item prop="customerCode">
                          <label slot="label"><svg-icon icon-class="login_user"></svg-icon>&nbsp;客户编号</label>
                          <el-input  v-model="loginForm.customerCode"></el-input>
                      </el-form-item>
                      <el-form-item prop="userName">
                          <label slot="label"><svg-icon icon-class="login_user"></svg-icon>&nbsp;用户编号</label>
                          <el-input  v-model="loginForm.userName"></el-input>
                      </el-form-item>
                      <el-form-item prop="password">
                          <label slot="label"><svg-icon icon-class="login_passwd"></svg-icon>&nbsp;密&#12288;&#12288;码</label>
                          <el-input type="password"  v-model="loginForm.password" @keyup.enter.native="handleLogin"></el-input>
                      </el-form-item>
                      <!--<el-form-item label="验证码" prop="code">
                        <el-input  v-model="loginForm.code"></el-input>
                      </el-form-item>-->
                      <el-form-item>
                          <el-button type="primary" class="login-button" :loading="loading" @click.native.prevent="handleLogin">
                              登录
                          </el-button>
                      </el-form-item>
                  </el-form>
              </div>
          </div>
          <div class="login-card-container1">
              <div class="container-item">
                  <span>&copy;2018北京爱博精电科技有限公司</span>
              </div>
              <div class="container-item">
                  <span style="padding-left: 0.8rem">售后服务电话：010-56390122</span>
              </div>
          </div>
      <!--</div>-->
  </div>
</template>

<script>
  import { identifierRegex } from '@/utils/validate'
  import { checkSmsAuth } from '@/api/smsAuth'
  export default {
    name: 'Login',
    data() {
      return {
        loginForm: {
          customerCode: '',
          userName: '',
          password: '',
          code: ''
        },
        loginRules: {
          customerCode: [{ required: true, pattern: identifierRegex, message: '请输入正确客户编号', trigger: 'blur' }],
          userName: [{ required: true, pattern: identifierRegex, message: '请输入正确的用户名', trigger: 'blur' }],
          password: [{ required: true, message: '密码必填', trigger: 'blur' }],
          code: [{ required: true, message: '验证码必填', trigger: 'blur' }]
        },
        loading: false
      }
    },
    mounted() {
      const loginCustomerCode = localStorage.getItem('loginCustomerCode')
      const loginUserName = localStorage.getItem('loginUserName')
      if (loginCustomerCode !== null && loginCustomerCode !== undefined && loginCustomerCode !== '') {
        this.loginForm.customerCode = loginCustomerCode
      }
      if (loginUserName !== null && loginUserName !== undefined && loginUserName !== '') {
        this.loginForm.userName = loginUserName
      }
    },
    methods: {
      showPwd: function() {
      },
      handleLogin: function() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true
            this.$store.dispatch('Login', this.loginForm).then(() => {
              localStorage.setItem('loginCustomerCode',this.loginForm.customerCode)
              localStorage.setItem('loginUserName',this.loginForm.userName)
              this.loading = false
              // 调用一次空接口，检测是否需短信认证
              checkSmsAuth().then(res => {
                // 不为40001则不需短信认证，直接进入主页
                if (res.code !== 40001) {
                  this.$router.push({ path: '/' })
                }
              })
            }).catch(() => {
              this.loading = false
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .login-container {
    font-size: 14px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: 100% 100%;
    background-image: url("~@/assets/login-background-2.png");

    .login-card-container {
      width: 876px;
      height: 383px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      background-size: 876px 383px;
      background-image: url("~@/assets/login-form-background.png");
      .login-card {
        width: 50%;
        height: 70%;
        opacity: 0.9;
        margin-top: 10%;
        .el-button {
          width: 150px;
          height: 30px;
          margin-top: 5px;
          padding: 0px;
          background-color: #009bac;
        }
        .el-form-item {
          margin-bottom: 18px;
        }
        .el-input {
          .el-input__inner {
            width: 220px;
            height: 26px;
            border-top-width: 0px;
            border-left-width: 0px;
            border-right-width: 0px;
            border-bottom-width: 1px;
            /*outline: medium;*/
          }
        }
        .el-form-item__label:before {
          content: ""
        }
        .el-form-item__error {
          padding-top: 2px;
        }
        .el-form-item__label {
          line-height: 30px;
        }
        .el-form-item__content {
          line-height: 10px;
        }
      }
    }
      .login-card-container1 {
          align-items: center;
          position: fixed;
          bottom: 0;
          .container-item{
              align-items: center;
              color: #009bac;
          }
      }
  }
</style>
